import { feedbackAnswerSlice } from '../store/slices/feedbackSlice';

export const programAnswer = feedbackAnswerSlice.reducer;
